export const encodeData = (data: object) => {
  const stringData = JSON.stringify(data);
  const encoder = new TextEncoder();
  const binaryData = encoder.encode(stringData).buffer;
  return binaryData;
};

export const decodeData = <T>(binaryData: Uint8Array): T => {
  const decoder = new TextDecoder();
  const stringData = decoder.decode(new Uint8Array(binaryData));
  const data: T = JSON.parse(stringData) as T;
  return data;
};
